export class RecommendationsUnit {
  price = 0;
  imageUrl = '';
}
